<template lang="pug">
#content.snap-content
  .overlay(@click="hide()")
  Marquee(:class="{ 'd-none': !whiteLabel }")
  toolBar
  .content-center
    .pagepanel
      .page-group
        template(v-if="$store.getters.language == 'cn'")
          cnContent
        template(v-else-if="$store.getters.language == 'vi'")
          viContent
        template(v-else-if="$store.getters.language == 'th'")
          thContent
        template(v-else-if="$store.getters.language == 'id'")
          idContent
        template(v-else-if="$store.getters.language == 'kr'")
          krContent
        template(v-else)
          enContent

  footerNav
</template>

<script>
import Marquee from "@/components/mobile/mainPanelControl/marquee";
import toolBar from "@/components/mobile/toolBar";
import footerNav from "@/components/mobile/footerNav";

import enContent from "@/components/mobile/rules/en/mma";
import cnContent from "@/components/mobile/rules/cn/mma";
import viContent from "@/components/mobile/rules/vi/mma";
import thContent from "@/components/mobile/rules/th/mma";
import idContent from "@/components/mobile/rules/id/mma";
import krContent from "@/components/mobile/rules/kr/mma";
import config from "@/config";

export default {
  components: {
    Marquee,
    toolBar,
    footerNav,
    enContent,
    cnContent,
    viContent,
    thContent,
    idContent,
    krContent
  },
  computed: {
    whiteLabel() {
      return config.whiteLabel == "1";
    }
  },
  methods: {
    hide(e) {
      var body = $("body");
      if (body.hasClass("snapjs-left")) {
        body.removeClass("snapjs-left");
      }
    }
  }
};
</script>